/**
 * Checks if the two objects are deeply inequal
 */
export const isObjectDeeplyChanged = (newObj?: unknown, oldObj?: unknown) =>
    JSON.stringify(newObj) !== JSON.stringify(oldObj);
